import { IdeyaSpinner } from '../../common/components/ideya-spinner.tsx'
import { useEffect } from 'react'
import { logout } from '../../utils/logout.ts'
import { useAuth0 } from '@auth0/auth0-react'
import { isAuth0, isInternalWebsite, isIppon } from '../../utils/helpers.ts'

export const Logout = () => {
  const { logout: auth0Logout } = useAuth0()

  useEffect(() => {
    if (isIppon) {
      localStorage.removeItem('apiAccessToken')
      localStorage.removeItem('disclaimerAccepted')
      localStorage.removeItem('ideya-error')
      auth0Logout({ logoutParams: { returnTo: window.location.origin } }).then(
        () => console.log('finished logging out')
      )
    } else if (isAuth0 && !isInternalWebsite) {
      localStorage.removeItem('apiAccessToken')
      localStorage.removeItem('disclaimerAccepted')
      localStorage.removeItem('ideya-error')
      auth0Logout({ logoutParams: { returnTo: window.location.origin } }).then(
        () => console.log('finished logging out')
      )
    } else {
      logout()
    }
  }, [])

  return (
    <>
      <div
        style={{
          width: '100%',
          height: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IdeyaSpinner />
      </div>
    </>
  )
}
